// =====================================================
// API SERVICE - ENDPOINTS ADICIONALES
// Agregar a src/api/agro.js
// =====================================================

import axios from "axios"

const BASE_URL = `${window.REACT_AGRO_URL}/ewanagro/api/agro`

// --- Helpers HTTP ---
const get = (url, config) => axios.get(url, config).then(res => res.data)
const post = (url, data) => axios.post(url, data).then(res => res.data)
const put = (url, data) => axios.put(url, data).then(res => res.data)
const del = url => axios.delete(url).then(res => res.data)

// --- AFIP / Productores ---

export const validarCuit = cuit =>
  axios.get(`${BASE_URL}/afip/validar/${cuit}`).then(res => res.data)

export const crearProductorDesdeAfip = cuit =>
  axios.post(`${BASE_URL}/productores/desde-afip/${cuit}`).then(res => res.data)

export const getProductores = () =>
  axios.get(`${BASE_URL}/productores`).then(res => res.data)

export const getProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}`).then(res => res.data)

export const getProductorByCuit = cuit =>
  axios.get(`${BASE_URL}/productores/cuit/${cuit}`).then(res => res.data)

export const getTiposProductor = async () => {
  const response = await axios.get(`${BASE_URL}/dominios/tipos-productor`)
  return response.data
}

// --- Establecimientos ---

export const getEstablecimientos = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/establecimientos`)
    .then(res => res.data)

// BDSJEA-466: reporte "Plan Productivo" del productor (solo lectura).
export const getReportePlanProductivo = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/reporte-plan-productivo`)
    .then(res => res.data)

export const getEstablecimiento = id =>
  axios.get(`${BASE_URL}/establecimientos/${id}`).then(res => res.data)

export const saveEstablecimiento = data =>
  axios.post(`${BASE_URL}/establecimientos`, data).then(res => res.data)

export const updateEstablecimiento = (id, data) =>
  axios.put(`${BASE_URL}/establecimientos/${id}`, data).then(res => res.data)

// ===== PRECIOS DE MERCADO =====

// export const getPreciosMercado = () =>
//   axios.get(`${BASE_URL}/precios`).then(res => res.data)

// export const getPreciosGranos = () =>
//   axios.get(`${BASE_URL}/precios/granos`).then(res => res.data)

// export const getPrecioCultivo = (codigoCultivo) =>
//   axios.get(`${BASE_URL}/precios/granos/${codigoCultivo}`).then(res => res.data)

// export const getPreciosHacienda = () =>
//   axios.get(`${BASE_URL}/precios/hacienda`).then(res => res.data)

export const calcularValorCosecha = (cultivo, superficie, rendimiento) =>
  axios
    .get(`${BASE_URL}/precios/calcular-cosecha`, {
      params: { cultivo, superficie, rendimiento },
    })
    .then(res => res.data)

export const getPrecioGrano = codigo =>
  axios.get(`${BASE_URL}/precios/granos/${codigo}`).then(res => res.data)

// BDSJEA-189: precio USD/tn desde valor_agro por zona del establecimiento + cultivo.
export const getPrecioReferenciaStock = (idEstablecimiento, codigoCultivo) =>
  axios
    .get(`${BASE_URL}/stock-agricola/precio-referencia`, {
      params: { idEstablecimiento, codigoCultivo },
    })
    .then(res => res.data)

export const getHistoricoPrecioGrano = (codigo, desde, hasta) =>
  axios
    .get(`${BASE_URL}/precios/granos/${codigo}/historico`, {
      params: { desde, hasta },
    })
    .then(res => res.data)

// export const actualizarPreciosGranos = () =>
//   axios.post(`${BASE_URL}/precios/granos/actualizar`).then(res => res.data)

export const getPrecioHacienda = codigo =>
  axios.get(`${BASE_URL}/precios/hacienda/${codigo}`).then(res => res.data)

// export const actualizarPreciosHacienda = () =>
//   axios.post(`${BASE_URL}/precios/hacienda/actualizar`).then(res => res.data)

/**
 * Obtiene todos los precios de todas las fuentes
 * Incluye: granos, futuros, bahiaBlanca, fob, hacienda
 */
export const getPreciosMercado = () =>
  axios.get(`${BASE_URL}/precios`).then(res => res.data)

/**
 * Obtiene precios de granos de Rosario (CAC-BCR)
 */
export const getPreciosGranos = () =>
  axios.get(`${BASE_URL}/precios/granos`).then(res => res.data)

/**
 * Obtiene precios futuros de MATBA-Rofex
 */
export const getPreciosFuturos = () =>
  axios.get(`${BASE_URL}/precios/futuros`).then(res => res.data)

/**
 * Obtiene precios de Bahía Blanca (CACBB)
 */
export const getPreciosBahiaBlanca = () =>
  axios.get(`${BASE_URL}/precios/bahia-blanca`).then(res => res.data)

/**
 * Obtiene precios FOB oficiales (MAGYP)
 */
export const getPreciosFob = () =>
  axios.get(`${BASE_URL}/precios/fob`).then(res => res.data)

/**
 * Obtiene precios de hacienda (Mercado Agroganadero)
 */
export const getPreciosHacienda = () =>
  axios.get(`${BASE_URL}/precios/hacienda`).then(res => res.data)

/**
 * Obtiene comparativo de precios de un cultivo en todas las plazas
 */
export const getComparativoCultivo = codigoCultivo =>
  axios
    .get(`${BASE_URL}/precios/comparativo/${codigoCultivo}`)
    .then(res => res.data)

/**
 * Obtiene precio de un cultivo específico
 */
export const getPrecioCultivo = codigoCultivo =>
  axios.get(`${BASE_URL}/precios/granos/${codigoCultivo}`).then(res => res.data)

// ==========================================
// ACTUALIZACIÓN FORZADA DE PRECIOS
// ==========================================

export const actualizarPreciosGranos = () =>
  axios.post(`${BASE_URL}/precios/granos/actualizar`).then(res => res.data)

export const actualizarPreciosFuturos = () =>
  axios.post(`${BASE_URL}/precios/futuros/actualizar`).then(res => res.data)

export const actualizarPreciosBahiaBlanca = () =>
  axios
    .post(`${BASE_URL}/precios/bahia-blanca/actualizar`)
    .then(res => res.data)

export const actualizarPreciosFob = () =>
  axios.post(`${BASE_URL}/precios/fob/actualizar`).then(res => res.data)

export const actualizarPreciosHacienda = () =>
  axios.post(`${BASE_URL}/precios/hacienda/actualizar`).then(res => res.data)

// --- Clima ---

export const getClimaEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/clima/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

export const getAlertasZona = codigoProvincia =>
  axios
    .get(`${BASE_URL}/clima/alertas/${codigoProvincia}`)
    .then(res => res.data)

export const getPronosticoEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/clima/establecimiento/${idEstablecimiento}/pronostico`)
    .then(res => res.data)

// --- Credenciales de servicios externos (BDSJEA-9) ---
//
// NINGUNO de estos endpoints devuelve el valor de una credencial. El unico
// que lo envia es rotarSecretoCredencial, y va por body de POST: nunca por
// query param, porque los query params quedan en el access log del nginx.

export const getCredenciales = () =>
  axios.get(`${BASE_URL}/credenciales`).then(res => res.data)

export const getCredencialesPorVencer = (dias = 60) =>
  axios
    .get(`${BASE_URL}/credenciales/por-vencer?dias=${dias}`)
    .then(res => res.data)

export const rotarSecretoCredencial = (id, valor) =>
  axios
    .post(`${BASE_URL}/credenciales/${id}/secreto`, { valor })
    .then(res => res.data)

export const cambiarEstadoCredencial = (id, activo) =>
  axios
    .put(`${BASE_URL}/credenciales/${id}/estado`, { activo })
    .then(res => res.data)

export const actualizarCredencial = (id, datos) =>
  axios.put(`${BASE_URL}/credenciales/${id}`, datos).then(res => res.data)

export const probarCredencial = id =>
  axios.post(`${BASE_URL}/credenciales/${id}/test`).then(res => res.data)

export const getAuditoriaCredencial = codigoServicio =>
  axios
    .get(`${BASE_URL}/credenciales/${codigoServicio}/auditoria`)
    .then(res => res.data)

export const invalidarCacheCredenciales = () =>
  axios.post(`${BASE_URL}/credenciales/invalidar-cache`).then(res => res.data)

// --- Alertas meteorológicas (SMN / CAP) ---

export const getAlertasVigentes = () =>
  axios.get(`${BASE_URL}/clima/alertas/vigentes`).then(res => res.data)

export const getAlertasEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/clima/alertas/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

export const getAlertasProductorClima = idProductor =>
  axios
    .get(`${BASE_URL}/clima/alertas/productor/${idProductor}`)
    .then(res => res.data)

export const sincronizarAlertas = () =>
  axios.post(`${BASE_URL}/clima/alertas/sincronizar`).then(res => res.data)

// --- Siembras ---

export const getSiembras = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/siembras`)
    .then(res => res.data)

export const getSiembra = id =>
  axios.get(`${BASE_URL}/siembras/${id}`).then(res => res.data)

export const saveSiembra = data =>
  axios.post(`${BASE_URL}/siembras`, data).then(res => res.data)

export const updateSiembra = (id, data) =>
  axios.put(`${BASE_URL}/siembras/${id}`, data).then(res => res.data)

// --- Stock Ganadero ---

export const getStockGanadero = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/stock-ganadero`)
    .then(res => res.data)

export const saveStockGanadero = data =>
  axios.post(`${BASE_URL}/stock-ganadero`, data).then(res => res.data)

// --- Scoring ---

// export const getScoringProductor = (idProductor) =>
//   axios.get(`${BASE_URL}/scoring/productor/${idProductor}`).then(res => res.data)

export const calcularScoring = idProductor =>
  axios
    .post(`${BASE_URL}/productores/${idProductor}/scoring/calcular`)
    .then(res => res.data)

// --- Dominios ---

// BDSJEA-409: catalogo de destino / uso de lote (TABLASGENERALES 146): [{ codigo, descripcion, orden, activo }]
export const getUsosLote = () =>
  axios.get(`${BASE_URL}/dominios/uso-lote`).then(res => res.data)

export const getProvincias = () =>
  axios.get(`${BASE_URL}/dominios/provincias`).then(res => res.data)

export const getDepartamentosPorProvincia = codigoProvincia =>
  axios
    .get(`${BASE_URL}/dominios/departamentos`, {
      params: { provincia: codigoProvincia },
    })
    .then(res => res.data)

export const getLocalidadesPorProvinciaYDepartamento = (
  codigoProvincia,
  departamento,
) =>
  axios
    .get(`${BASE_URL}/dominios/localidades`, {
      params: { provincia: codigoProvincia, departamento },
    })
    .then(res => res.data)

export const getLocalidadesPorCodigoPostal = codigoPostal =>
  axios
    .get(`${BASE_URL}/dominios/localidades/cp`, {
      params: { cp: codigoPostal },
    })
    .then(res => res.data)

export const getCultivos = () =>
  axios.get(`${BASE_URL}/dominios/cultivos`).then(res => res.data)

export const getTiposTenencia = () =>
  axios.get(`${BASE_URL}/dominios/tipos-tenencia`).then(res => res.data)

export const getCampanas = () =>
  axios.get(`${BASE_URL}/dominios/campanas`).then(res => res.data)

export const saveCampana = data =>
  axios.post(`${BASE_URL}/dominios/campanas`, data).then(res => res.data)

// --- Productores (adicionales) ---

export const saveProductor = data =>
  axios.post(`${BASE_URL}/productores`, data).then(res => res.data)

export const updateProductor = (id, data) =>
  axios.put(`${BASE_URL}/productores/${id}`, data).then(res => res.data)

export const getSiembrasProductor = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/siembras`)
    .then(res => res.data)

export const getStockGanaderoProductor = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/stock-ganadero`)
    .then(res => res.data)

export const getMovimientosProductor = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/movimientos`)
    .then(res => res.data)

export const deleteProductor = id =>
  axios.delete(`${BASE_URL}/productores/${id}`).then(res => res.data)

export const sincronizarAfip = idProductor =>
  axios
    .post(`${BASE_URL}/productores/${idProductor}/sincronizar-afip`)
    .then(res => res.data)

// --- Dashboard ---

export const getDashboardStats = () =>
  axios.get(`${BASE_URL}/dashboard/stats`).then(res => res.data)

export const getDashboardAlertas = () =>
  axios.get(`${BASE_URL}/dashboard/alertas`).then(res => res.data)

// --- Histórico Clima ---

export const getHistoricoClima = (idEstablecimiento, desde, hasta) =>
  axios
    .get(`${BASE_URL}/clima/establecimiento/${idEstablecimiento}/historico`, {
      params: { desde, hasta },
    })
    .then(res => res.data)

// --- Movimientos Ganaderos ---

export const getMovimientosEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/movimientos`)
    .then(res => res.data)

export const saveMovimientoGanadero = data =>
  axios.post(`${BASE_URL}/movimientos-ganaderos`, data).then(res => res.data)

// --- Reportes ---

export const getReporteProductor = idProductor =>
  axios
    .get(`${BASE_URL}/reportes/productor/${idProductor}`)
    .then(res => res.data)

export const getReporteCampana = codigoCampana =>
  axios
    .get(`${BASE_URL}/reportes/campana/${codigoCampana}`)
    .then(res => res.data)

export const getReporteScoring = params =>
  axios.get(`${BASE_URL}/reportes/scoring`, { params }).then(res => res.data)

// --- Polígonos ---

export const getPoligonosEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos`)
    .then(res => res.data)

// export const savePoligono = (idEstablecimiento, data) =>
//   axios.post(`${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos`, data).then(res => res.data)

// BDSJEA-462: edita superficie y/o destino de un lote (data: { superficieHa?, usoActual? }; lo ausente no cambia).
export const updatePoligono = (idPoligono, data) =>
  axios
    .put(`${BASE_URL}/establecimientos/poligonos/${idPoligono}`, data)
    .then(res => res.data)

// export const deletePoligono = (idPoligono) =>
//   axios.delete(`${BASE_URL}/poligonos/${idPoligono}`).then(res => res.data)

export const getPoligonosByEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos`)
    .then(res => res.data)

export const savePoligono = data =>
  axios
    .post(`${BASE_URL}/establecimientos/poligonos`, data)
    .then(res => res.data)

export const deletePoligono = idPoligono =>
  axios
    .delete(`${BASE_URL}/establecimientos/poligonos/${idPoligono}`)
    .then(res => res.data)

// --- Documentos ---

export const getDocumentosProductor = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/documentos`)
    .then(res => res.data)

export const getDocumentosEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/documentos`)
    .then(res => res.data)

export const uploadDocumento = (idEntidad, tipoEntidad, file, metadata) => {
  const formData = new FormData()
  formData.append("file", file)
  formData.append("metadata", JSON.stringify(metadata))

  return axios
    .post(`${BASE_URL}/documentos/${tipoEntidad}/${idEntidad}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(res => res.data)
}

export const deleteDocumento = idDocumento =>
  axios.delete(`${BASE_URL}/documentos/${idDocumento}`).then(res => res.data)

// --- Costos y Márgenes ---

export const getCostosAgricolasEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/costos-agricolas`)
    .then(res => res.data)

export const saveCostoAgricola = (idSiembra, data) =>
  axios
    .post(`${BASE_URL}/siembras/${idSiembra}/costos`, data)
    .then(res => res.data)

export const calcularMargenSiembra = idSiembra =>
  axios
    .post(`${BASE_URL}/siembras/${idSiembra}/calcular-margen`)
    .then(res => res.data)

// --- Indicadores Ganaderos ---

export const getIndicadoresGanaderos = (idEstablecimiento, anio) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/indicadores-ganaderos`,
      {
        params: { anio },
      },
    )
    .then(res => res.data)

export const saveIndicadorGanadero = data =>
  axios.post(`${BASE_URL}/indicadores-ganaderos`, data).then(res => res.data)

// --- Ventas Agrícolas ---

export const getVentasSiembra = idSiembra =>
  axios.get(`${BASE_URL}/siembras/${idSiembra}/ventas`).then(res => res.data)

export const saveVentaAgricola = data =>
  axios.post(`${BASE_URL}/ventas-agricolas`, data).then(res => res.data)

export const updateVentaAgricola = (id, data) =>
  axios.put(`${BASE_URL}/ventas-agricolas/${id}`, data).then(res => res.data)

// --- Imágenes Satelitales ---

export const getImagenesSatelitales = (idEstablecimiento, desde, hasta) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/imagenes-satelitales`,
      {
        params: { desde, hasta },
      },
    )
    .then(res => res.data)

export const solicitarImagenSatelital = (idEstablecimiento, fecha) =>
  axios
    .post(`${BASE_URL}/satelital/solicitar`, { idEstablecimiento, fecha })
    .then(res => res.data)

// --- Búsquedas avanzadas ---

export const buscarProductores = query =>
  axios
    .get(`${BASE_URL}/productores/buscar`, { params: { q: query } })
    .then(res => res.data)

// BDSJEA-444: busqueda de productores con paginacion, limite y orden de SERVIDOR.
// GET /productores/busqueda -> { contenido, total, totalCoincidencias, pagina, tamanio, limite, limiteAplicado,
// orden, sentido }. `total` ya esta acotado por el limite efectivo (min(coincidencias, limite)); `limite` 0 = «Todos»
// (el servidor lo acota). Un 400 trae un mensaje descriptivo que el llamador debe mostrar.
export const buscarProductoresPaginado = (
  {
    q = "",
    page = 0,
    size = 100,
    limite = 1000,
    orden = "nombre",
    sentido = "asc",
  } = {},
  { signal } = {},
) =>
  axios
    .get(`${BASE_URL}/productores/busqueda`, {
      params: { q, page, size, limite, orden, sentido },
      signal,
    })
    .then(res => res.data)

export const buscarEstablecimientos = params =>
  axios
    .get(`${BASE_URL}/establecimientos/buscar`, { params })
    .then(res => res.data)

// --- Exportaciones ---

export const exportarDatosProductor = (idProductor, formato = "xlsx") =>
  axios
    .get(`${BASE_URL}/exportar/productor/${idProductor}`, {
      params: { formato },
      responseType: "blob",
    })
    .then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", `productor_${idProductor}.${formato}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    })

// --- Helpers ---

/**
 * Wrapper para llamadas con manejo de errores estándar
 */
export const apiCall = async (fn, errorMessage = "Error en la operación") => {
  try {
    return await fn()
  } catch (error) {
    const mensaje =
      error.response?.data?.mensaje || error.message || errorMessage
    throw new Error(mensaje)
  }
}

/**
 * Construye query params limpiando valores vacíos
 */
export const buildParams = params => {
  const cleaned = {}
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      cleaned[key] = value
    }
  })
  return cleaned
}

// BDSJEA-165: rendimiento y costo sugeridos para una siembra nueva. La zona no
// se manda: la infiere el backend del establecimiento.
export const getSugerenciaSiembra = (idEstablecimiento, codigoCultivo) =>
  axios
    .get(`${BASE_URL}/siembras/sugerencia`, {
      params: { idEstablecimiento, codigoCultivo },
    })
    .then(res => res.data)

// ===== TAMBO (BDSJEA-167) =====
// Devuelve null cuando el establecimiento no tiene tambo: el backend responde
// 204 y axios deja data vacia.
// Parametros del banco para pre-llenar un tambo nuevo.
export const getValoresPorDefectoTambo = () =>
  axios.get(`${BASE_URL}/tambos/valores-por-defecto`).then(res => res.data)

export const getTamboPorEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/tambos/establecimiento/${idEstablecimiento}`)
    .then(res => res.data || null)

export const getTambosPorProductor = idProductor =>
  axios.get(`${BASE_URL}/tambos/productor/${idProductor}`).then(res => res.data)

export const guardarTambo = (idEstablecimiento, data) =>
  axios
    .put(`${BASE_URL}/tambos/establecimiento/${idEstablecimiento}`, data)
    .then(res => res.data)

export const eliminarTambo = idEstablecimiento =>
  axios
    .delete(`${BASE_URL}/tambos/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

// ===== PROCESOS PROGRAMADOS (BDSJEA-166) =====
export const getProcesos = () =>
  axios.get(`${BASE_URL}/procesos`).then(res => res.data)

export const getHistorialProceso = (codigo, limite = 20) =>
  axios
    .get(`${BASE_URL}/procesos/${codigo}/historial`, { params: { limite } })
    .then(res => res.data)

export const ejecutarProceso = codigo =>
  axios.post(`${BASE_URL}/procesos/${codigo}/ejecutar`).then(res => res.data)

// ===== ESTABLECIMIENTOS =====

// BDSJEA-134: el RENSPA sale de las pantallas, asi que este helper queda sin
// consumidores en el front. Se elimina de aca; el endpoint del backend
// (/establecimientos/renspa/{renspa}) se deja porque puede usarse desde una
// integracion externa.

export const deleteEstablecimiento = id =>
  axios.delete(`${BASE_URL}/establecimientos/${id}`).then(res => res.data)

// Polígonos (lotes)
export const getPoligonos = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos`)
    .then(res => res.data)

// ===== SIEMBRAS =====

export const getSiembrasPorEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/siembras/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

export const getSiembrasPorProductor = idProductor =>
  axios
    .get(`${BASE_URL}/siembras/productor/${idProductor}`)
    .then(res => res.data)

export const getSiembrasPorCampana = codigoCampana =>
  axios
    .get(`${BASE_URL}/siembras/campana/${codigoCampana}`)
    .then(res => res.data)

export const registrarCosecha = (idSiembra, data) =>
  axios
    .post(`${BASE_URL}/siembras/${idSiembra}/cosecha`, data)
    .then(res => res.data)

export const deleteSiembra = id =>
  axios.delete(`${BASE_URL}/siembras/${id}`).then(res => res.data)

export const getResumenCultivos = (idProductor, campana = null) =>
  axios
    .get(`${BASE_URL}/siembras/productor/${idProductor}/resumen`, {
      params: campana ? { campana } : {},
    })
    .then(res => res.data)

// ===== STOCK GANADERO =====

export const getStockPorEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/stock-ganadero/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

export const getStockPorProductor = idProductor =>
  axios
    .get(`${BASE_URL}/stock-ganadero/productor/${idProductor}`)
    .then(res => res.data)

export const getResumenGanadero = idProductor =>
  axios
    .get(`${BASE_URL}/stock-ganadero/productor/${idProductor}/resumen`)
    .then(res => res.data)

export const saveStock = data =>
  axios.post(`${BASE_URL}/stock-ganadero`, data).then(res => res.data)

export const getMovimientos = (idEstablecimiento, desde = null, hasta = null) =>
  axios
    .get(
      `${BASE_URL}/stock-ganadero/movimientos/establecimiento/${idEstablecimiento}`,
      {
        params: { desde, hasta },
      },
    )
    .then(res => res.data)

export const getTodosMovimientos = (
  desde = null,
  hasta = null,
  idProductor = null,
) =>
  axios
    .get(`${BASE_URL}/stock-ganadero/movimientos`, {
      params: { desde, hasta, idProductor },
    })
    .then(res => res.data)

export const saveMovimiento = data =>
  axios
    .post(`${BASE_URL}/stock-ganadero/movimientos`, data)
    .then(res => res.data)

export const getStockDisponibleEstablecimiento = idEstablecimiento =>
  axios
    .get(
      `${BASE_URL}/stock-ganadero/establecimiento/${idEstablecimiento}/disponible`,
    )
    .then(res => res.data)

// ===== STOCK AGRÍCOLA =====

export const getStockAgricolaPorEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/stock-agricola/establecimiento/${idEstablecimiento}`)
    .then(res => res.data)

export const getStockAgricolaPorProductor = idProductor =>
  axios
    .get(`${BASE_URL}/stock-agricola/productor/${idProductor}`)
    .then(res => res.data)

export const getResumenAgricola = idProductor =>
  axios
    .get(`${BASE_URL}/stock-agricola/productor/${idProductor}/resumen`)
    .then(res => res.data)

export const saveStockAgricola = data =>
  axios.post(`${BASE_URL}/stock-agricola`, data).then(res => res.data)

export const updateStockAgricola = (id, data) =>
  axios.put(`${BASE_URL}/stock-agricola/${id}`, data).then(res => res.data)

export const deleteStockAgricola = id =>
  axios.delete(`${BASE_URL}/stock-agricola/${id}`).then(res => res.data)

export const getMovimientosAgricola = (
  idEstablecimiento,
  desde = null,
  hasta = null,
) =>
  axios
    .get(
      `${BASE_URL}/stock-agricola/movimientos/establecimiento/${idEstablecimiento}`,
      {
        params: { desde, hasta },
      },
    )
    .then(res => res.data)

export const getTodosMovimientosAgricola = (
  desde = null,
  hasta = null,
  idProductor = null,
) =>
  axios
    .get(`${BASE_URL}/stock-agricola/movimientos`, {
      params: { desde, hasta, idProductor },
    })
    .then(res => res.data)

export const saveMovimientoAgricola = data =>
  axios
    .post(`${BASE_URL}/stock-agricola/movimientos`, data)
    .then(res => res.data)

export const getTiposAlmacenamiento = () =>
  axios.get(`${BASE_URL}/dominios/tipos-almacenamiento`).then(res => res.data)

// ===== CLIMA =====

export const getAlertasClimaEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/clima/alertas`)
    .then(res => res.data)

export const getAlertasPorProvincia = codigoProvincia =>
  axios
    .get(`${BASE_URL}/clima/alertas/${codigoProvincia}`)
    .then(res => res.data)

// ===== NDVI / SATELITAL =====

// export const getNdviEstablecimiento = (idEstablecimiento) =>
//   axios.get(`${BASE_URL}/establecimientos/${idEstablecimiento}/ndvi`).then(res => res.data)

// export const actualizarNdvi = (idEstablecimiento) =>
//   axios.post(`${BASE_URL}/establecimientos/${idEstablecimiento}/ndvi/actualizar`).then(res => res.data)

export const getNdviActual = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/satelital/ndvi/${idEstablecimiento}`)
    .then(res => res.data)

export const getSerieNdvi = (idEstablecimiento, desde, hasta) =>
  axios
    .get(`${BASE_URL}/satelital/ndvi/${idEstablecimiento}/serie`, {
      params: { desde, hasta },
    })
    .then(res => res.data)

// NDVI POR POLÍGONO

/**
 * Obtiene el NDVI actual de un polígono específico
 * @param {number} idPoligono - ID del polígono/lote
 * @returns {Promise<Object>} NDVI actual con fecha, valor promedio, rango y estado
 */
export const getNdviPoligono = async idPoligono => {
  const response = await axios.get(
    `${BASE_URL}/satelital/ndvi/poligonos/${idPoligono}`,
  )
  return response.data
}

/**
 * Obtiene la serie histórica de NDVI de un polígono
 * @param {number} idPoligono
 * @param {string} fechaDesde - Fecha inicio (YYYY-MM-DD)
 * @param {string} fechaHasta - Fecha fin (YYYY-MM-DD)
 * @returns {Promise<Array>} Serie temporal de valores NDVI
 */
export const getSerieNdviPoligono = async (idPoligono, desde, hasta) => {
  const response = await axios.get(
    `${BASE_URL}/satelital/ndvi/poligonos/${idPoligono}/serie`,
    {
      params: { desde, hasta },
    },
  )
  return response.data
}

// =====================================================
// ANÁLISIS SATELITAL CON IA
// =====================================================

/**
 * Genera un análisis de imágenes satelitales usando IA
 * @param {number} idProductor
 * @param {Object} datos - Datos para el análisis (imágenes, NDVI, fechas, etc.)
 * @returns {Promise<Object>} Análisis generado con resumen, tendencias y recomendaciones
 */
export const generarAnalisisIASatelital = async (idProductor, datos) => {
  const response = await axios.post(
    `${BASE_URL}/productores/${idProductor}/analisis-satelital/ia`,
    datos,
  )
  return response.data
}

/**
 * Obtiene análisis satelitales previos de un productor
 * @param {number} idProductor
 * @returns {Promise<Array>} Lista de análisis previos
 */
export const getAnalisisSatelitalesProductor = async idProductor => {
  const response = await axios.get(
    `${BASE_URL}/productores/${idProductor}/analisis-satelital`,
  )
  return response.data
}

// ===== SCORING =====

export const getScoring = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/scoring`)
    .then(res => res.data)

export const getHistoricoScoring = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/scoring/historico`)
    .then(res => res.data)

// ===== DASHBOARD =====

export const getDashboard = () =>
  axios.get(`${BASE_URL}/dashboard`).then(res => res.data)

// ===== DOMINIOS (Catálogos) =====

export const getEspeciesGanaderas = () =>
  axios.get(`${BASE_URL}/dominios/especies-ganaderas`).then(res => res.data)

export const getEntidades = () =>
  axios.get(`${BASE_URL}/dominios/entidades`).then(res => res.data)

export const getTodasEntidades = () =>
  axios.get(`${BASE_URL}/dominios/entidades/all`).then(res => res.data)

export const saveEntidad = data => post(`${BASE_URL}/dominios/entidades`, data)

export const deleteEntidad = id => del(`${BASE_URL}/dominios/entidades/${id}`)

export const restaurarEntidad = id =>
  axios
    .post(`${BASE_URL}/dominios/entidades/${id}/restaurar`)
    .then(res => res.data)

export const getEstadosFenologicos = (codigoCultivo = null) =>
  axios
    .get(`${BASE_URL}/dominios/estados-fenologicos`, {
      params: codigoCultivo ? { cultivo: codigoCultivo } : {},
    })
    .then(res => res.data)

// ===== HELPERS =====

/**
 * Formatea número como moneda USD
 */
export const formatUsd = value => {
  if (value === null || value === undefined) return "-"
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value)
}

/**
 * Formatea número con separador de miles
 */
export const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined) return "-"
  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)
}

// ==========================================
// PRODUCTORES
// ==========================================

export const crearProductor = data => post(`${BASE_URL}/productores`, data)

export const actualizarProductor = (id, data) =>
  put(`${BASE_URL}/productores/${id}`, data)

export const getEstablecimientosProductor = idProductor =>
  get(`${BASE_URL}/productores/${idProductor}/establecimientos`)

export const getStockProductor = idProductor =>
  get(`${BASE_URL}/productores/${idProductor}/stock-ganadero`)

// ==========================================
// ESTABLECIMIENTOS
// ==========================================

export const crearEstablecimiento = (idProductor, data) =>
  post(`${BASE_URL}/productores/${idProductor}/establecimientos`, data)

export const actualizarEstablecimiento = (id, data) =>
  put(`${BASE_URL}/establecimientos/${id}`, data)

// ==========================================
// SIEMBRAS
// ==========================================

export const crearSiembra = (idEstablecimiento, data) =>
  post(`${BASE_URL}/establecimientos/${idEstablecimiento}/siembras`, data)

export const actualizarSiembra = (id, data) =>
  put(`${BASE_URL}/siembras/${id}`, data)

export const eliminarSiembra = id => del(`${BASE_URL}/siembras/${id}`)

// ==========================================
// STOCK GANADERO
// ==========================================

export const actualizarStock = (idEstablecimiento, data) =>
  put(`${BASE_URL}/establecimientos/${idEstablecimiento}/stock-ganadero`, data)

// ==========================================
// CLIMA
// ==========================================

export const getAlertasClimaticas = codigoProvincia =>
  get(`${BASE_URL}/clima/alertas/${codigoProvincia}`)

// ==========================================
// SATELITAL / NDVI
// ==========================================

export const actualizarIndicesSatelitales = () =>
  post(`${BASE_URL}/satelital/actualizar-indices`)

// ==========================================
// DASHBOARD
// ==========================================

export const getDashboardPreciosResumen = () =>
  get(`${BASE_URL}/dashboard/precios-resumen`)

// --- Datos de Suelo (GeoINTA) ---

export const getDatosSueloEstablecimiento = (idEstablecimiento, force) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/suelo?actualizar=${force ? force : ""}`,
    )
    .then(res => res.data)

export const getDatosSueloPoligono = idPoligono =>
  axios
    .get(`${BASE_URL}/establecimientos/poligonos/${idPoligono}/suelo`)
    .then(res => res.data)

// --- Establecimientos ---

export const createEstablecimiento = data =>
  axios.post(`${BASE_URL}/establecimientos`, data).then(res => res.data)

// --- Imágenes Satelitales (Sentinel Hub) ---

/**
 * Obtiene imagen satelital completa para un polígono en una fecha.
 * Devuelve URLs para TRUE-COLOR, NDVI y MOISTURE.
 *
 * @param {number} idEstablecimiento
 * @param {number} idPoligono
 * @param {string} fecha - formato YYYY-MM-DD
 * @returns {Promise<ImagenSatelitalViewDTO>}
 */
export const getImagenPoligono = (idEstablecimiento, idPoligono, fecha) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos/${idPoligono}/imagen`,
      {
        params: { fecha },
      },
    )
    .then(res => res.data)

/**
 * Obtiene serie temporal de imágenes para comparación.
 *
 * @param {number} idEstablecimiento
 * @param {number} idPoligono
 * @param {string} desde - formato YYYY-MM-DD
 * @param {string} hasta - formato YYYY-MM-DD
 * @param {string} layer - TRUE-COLOR, NDVI, MOISTURE
 * @param {number} intervaloDias - cada cuántos días (default: 7)
 * @returns {Promise<ImagenSatelitalViewDTO[]>}
 */
export const getSerieImagenes = (
  idEstablecimiento,
  idPoligono,
  desde,
  hasta,
  layer = "TRUE-COLOR",
  intervaloDias = 7,
) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos/${idPoligono}/imagenes/serie`,
      {
        params: { desde, hasta, layer, intervaloDias },
      },
    )
    .then(res => res.data)

/**
 * Genera URL de imagen para una visualización específica.
 *
 * @param {number} idEstablecimiento
 * @param {number} idPoligono
 * @param {string} fecha
 * @param {string} layer
 * @param {number} width
 * @param {number} height
 * @returns {Promise<{url: string, fecha: string, layer: string}>}
 */
export const getUrlImagenSatelital = (
  idEstablecimiento,
  idPoligono,
  fecha,
  layer = "TRUE-COLOR",
  width = 800,
  height = 600,
) =>
  axios
    .get(
      `${BASE_URL}/establecimientos/${idEstablecimiento}/poligonos/${idPoligono}/imagen/url`,
      {
        params: { fecha, layer, width, height },
      },
    )
    .then(res => res.data)

// =====================================================
// EVALUACIONES CREDITICIAS
// =====================================================

/**
 * Obtiene lista de evaluaciones con filtros opcionales.
 *
 * @param {Object} filtros - { estado: 'PENDIENTE' | 'APROBADA' | 'RECHAZADA' }
 * @returns {Promise<EvaluacionListDTO[]>}
 */
export const getEvaluaciones = (filtros = {}) => {
  const params = new URLSearchParams()
  if (filtros.estado) params.append("estado", filtros.estado)

  return axios.get(`${BASE_URL}/evaluaciones?${params}`).then(res => res.data)
}

/**
 * Obtiene el detalle completo de una evaluación (ResumenEjecutivo).
 *
 * @param {number} idEvaluacion
 * @returns {Promise<ResumenEjecutivoDTO>}
 */
export const getEvaluacion = idEvaluacion =>
  axios.get(`${BASE_URL}/evaluaciones/${idEvaluacion}`).then(res => res.data)

/**
 * Crea una nueva evaluación crediticia.
 * Procesa los datos del formulario y genera el scoring.
 *
 * @param {SolicitudCreditoDTO} datos - Datos del formulario
 * @returns {Promise<ResumenEjecutivoDTO>}
 */
export const crearEvaluacion = datos =>
  axios.post(`${BASE_URL}/evaluaciones`, datos).then(res => res.data)

/**
 * Aprueba una evaluación.
 *
 * @param {number} idEvaluacion
 * @returns {Promise<void>}
 */
export const aprobarEvaluacion = idEvaluacion =>
  axios
    .put(`${BASE_URL}/evaluaciones/${idEvaluacion}/aprobar`)
    .then(res => res.data)

/**
 * Rechaza una evaluación con motivo.
 *
 * @param {number} idEvaluacion
 * @param {string} motivo
 * @returns {Promise<void>}
 */
export const rechazarEvaluacion = (idEvaluacion, motivo) =>
  axios
    .put(`${BASE_URL}/evaluaciones/${idEvaluacion}/rechazar`, { motivo })
    .then(res => res.data)

/**
 * Importa datos desde archivo Excel.
 *
 * @param {File} archivo - Archivo Excel
 * @returns {Promise<SolicitudCreditoDTO>} - Datos parseados del Excel
 */
export const importarExcel = archivo => {
  const formData = new FormData()
  formData.append("archivo", archivo)

  return axios
    .post(`${BASE_URL}/evaluaciones/importar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(res => res.data)
}

/**
 * Exporta el resumen ejecutivo a PDF.
 *
 * @param {number} idEvaluacion
 * @returns {Promise<Blob>} - Archivo PDF
 */
export const exportarResumenPdf = idEvaluacion =>
  axios
    .get(`${BASE_URL}/evaluaciones/${idEvaluacion}/pdf`, {
      responseType: "blob",
    })
    .then(res => res.data)

// =====================================================
// MODIFICACIONES PARA src/api/agro.js
// Agregar función para generar PDF del Informe Agropecuario
// =====================================================

// ========== AGREGAR ESTA FUNCIÓN AL FINAL DEL ARCHIVO ==========

/**
 * Genera el PDF del Informe Agropecuario Integral
 *
 * @param {Object} informeData - Datos del informe
 * @param {string} informeData.razonSocial - Razón social del productor
 * @param {string} informeData.cuit - CUIT del productor
 * @param {string} informeData.zona - Zona productiva
 * @param {number} informeData.hectareasTotales - Total de hectáreas
 * @param {string} informeData.tipoActividad - Tipo de actividad principal
 * @param {string} informeData.campanaActual - Campaña agrícola actual
 * @param {Array} informeData.cultivos - Lista de cultivos con análisis
 * @param {Object} informeData.ganaderia - Datos de ganadería (cria, ventas, invernada)
 * @param {Object} informeData.tambo - Datos de tambo
 * @param {Object} informeData.metricas - Métricas calculadas
 * @param {string} informeData.comentarios - Comentarios del analista
 * @param {string} informeData.fechaGeneracion - Fecha de generación
 * @param {string} informeData.analistaResponsable - Analista responsable
 * @param {string} informeData.version - Versión del informe
 * @param {string} informeData.origenDatos - Origen de los datos (Sistema/Excel)
 * @returns {Promise<Blob>} - Archivo PDF como Blob
 */
// BDSJEA-172: el PDF se arma en el servidor desde el id del productor. La
// versión que posteaba el payload construido en el navegador quedó abajo, en
// desuso: varios campos no se llenaban y el documento no coincidía ni con la
// pantalla ni consigo mismo.
export const generarPdfInformeAgroPorProductor = idProductor =>
  axios
    .get(`${BASE_URL}/informes/agropecuario/${idProductor}/pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    })
    .then(res => res.data)

export const generarPdfInformeAgro = informeData =>
  axios
    .post(`${BASE_URL}/informes/agropecuario/pdf`, informeData, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    })
    .then(res => res.data)

// =====================================================
// TAMBIÉN AGREGAR (si no existe) - Preview del PDF
// =====================================================

/**
 * Genera preview del PDF del Informe Agropecuario (inline, no descarga)
 *
 * @param {Object} informeData - Datos del informe (misma estructura que generarPdfInformeAgro)
 * @returns {Promise<Blob>} - Archivo PDF como Blob para visualización
 */
export const previewPdfInformeAgro = informeData =>
  axios
    .post(`${BASE_URL}/informes/agropecuario/preview`, informeData, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/pdf",
      },
    })
    .then(res => res.data)

// =====================================================
// EJEMPLO DE ESTRUCTURA DE informeData
// =====================================================
/*
const informeDataEjemplo = {
  // Información del cliente
  razonSocial: "El Campo SA",
  cuit: "30-12345678-9",
  zona: "S.E. Buenos Aires",
  hectareasTotales: 1000,
  tipoActividad: "Agropecuario",
  campanaActual: "2024/2025",
  
  // Cultivos
  cultivos: [
    {
      cultivo: "Trigo",
      zona: "S.E. Buenos Aires",
      hectareas: 230,
      rendimiento: 35,
      precioACosecha: 220,
      gastosComercializacion: 2,
      arrendamiento: 35,
      costoProductivo: 3
    },
    // ... más cultivos
  ],
  
  // Ganadería
  ganaderia: {
    cria: {
      "Vacas": 50,
      "Vaquillonas": 50,
      "Terneras": 200,
      "Toros": 10
    },
    ventas: {
      "Novillos": 30,
      "Vacas Descarte": 15
    },
    invernada: {
      "Novillitos": 100
    }
  },
  
  // Tambo
  tambo: {
    vacasEnOrdene: 4,
    vacasVacias: 2,
    vaquillonasYTerneras: 10,
    litrosPorDia: 22,
    porcentajeTambero: 12,
    precioVaquillona: 900
  },
  
  // Métricas calculadas
  metricas: {
    totalSuperficie: 880,
    ingresosBrutoTotal: 159160,
    costosDirectosTotal: 37054,
    margenBrutoTotal: 122106,
    ingresoGanadero: 76140,
    costosGanaderia: 34150,
    margenGanaderia: 41990,
    ingresoTambo: 12078,
    costosTambo: 7200,
    margenTambo: 4878,
    ingresoTotal: 247378,
    costosTotal: 78404,
    margenNetoTotal: 168974,
    rentabilidadSobreVentas: 68.31,
    rentabilidadPorHectarea: 192,
    capacidadPago: 0.169,
    diversificacion: 6,
    intensidadUso: 88
  },
  
  // Metadatos
  comentarios: "El productor presenta una buena diversificación...",
  fechaGeneracion: "2026-01-18T15:22:00.000Z",
  analistaResponsable: "Sistema Automático",
  version: "2.1",
  origenDatos: "Excel - Datos Actividad Agropecuaria.xlsx"
}
*/

// Agregar en api/agro.js
export const getMargenesPorProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}/margenes`).then(res => res.data)
export const getCostosPorProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}/costos`).then(res => res.data)
export const getScoringProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}/scoring`).then(res => res.data)
export const getIndicesVegetacion = id =>
  axios.get(`${BASE_URL}/productores/${id}/ndvi`).then(res => res.data)
export const getEvaluacionesProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}/evaluaciones`).then(res => res.data)
export const getAlertasProductor = id =>
  axios.get(`${BASE_URL}/productores/${id}/alertas`).then(res => res.data)

// --- Parcelas de Establecimiento ---

/**
 * Lista todas las parcelas de un establecimiento.
 * @param {number} idEstablecimiento
 * @returns {Promise<EstablecimientoParcelaListDTO[]>}
 */
export const getParcelasEstablecimiento = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/parcelas`)
    .then(res => res.data)

/**
 * Obtiene el detalle de una parcela.
 * @param {number} idParcela
 * @returns {Promise<EstablecimientoParcelaDetalleDTO>}
 */
export const getParcela = idParcela =>
  axios.get(`${BASE_URL}/parcelas/${idParcela}`).then(res => res.data)

/**
 * Crea una nueva parcela en un establecimiento.
 * @param {number} idEstablecimiento
 * @param {EstablecimientoParcelaCreateDTO} data
 * @returns {Promise<EstablecimientoParcelaDetalleDTO>}
 */
export const createParcela = (idEstablecimiento, data) =>
  axios
    .post(`${BASE_URL}/establecimientos/${idEstablecimiento}/parcelas`, data)
    .then(res => res.data)

/**
 * Actualiza una parcela existente.
 * @param {number} idParcela
 * @param {EstablecimientoParcelaUpdateDTO} data
 * @returns {Promise<EstablecimientoParcelaDetalleDTO>}
 */
export const updateParcela = (idParcela, data) =>
  axios.put(`${BASE_URL}/parcelas/${idParcela}`, data).then(res => res.data)

/**
 * Elimina una parcela.
 * @param {number} idParcela
 * @returns {Promise<void>}
 */
export const deleteParcela = idParcela =>
  axios.delete(`${BASE_URL}/parcelas/${idParcela}`).then(res => res.data)

/**
 * Obtiene resumen de parcelas de un establecimiento.
 * @param {number} idEstablecimiento
 * @returns {Promise<ParcelasResumenDTO>}
 */
export const getParcelasResumen = idEstablecimiento =>
  axios
    .get(`${BASE_URL}/establecimientos/${idEstablecimiento}/parcelas/resumen`)
    .then(res => res.data)

// =====================================================
// ADMINISTRACIÓN DE PARÁMETROS AGROPECUARIOS
// =====================================================

// --- Zonas Agropecuarias ---
// export const getZonasAgro = () =>
//   axios.get(`${BASE_URL}/dominios/zonas`).then(res => res.data)

// export const saveZonaAgro = (data) =>
//   axios.post(`${BASE_URL}/dominios/zonas`, data).then(res => res.data)

// export const deleteZonaAgro = (id) =>
//   axios.delete(`${BASE_URL}/dominios/zonas/${id}`).then(res => res.data)

// // --- Conceptos Plan Productivo ---
// export const getConceptosPlan = () =>
//   axios.get(`${BASE_URL}/dominios/conceptos-plan`).then(res => res.data)

// export const saveConceptoPlan = (data) =>
//   axios.post(`${BASE_URL}/dominios/conceptos-plan`, data).then(res => res.data)

// export const deleteConceptoPlan = (id) =>
//   axios.delete(`${BASE_URL}/dominios/conceptos-plan/${id}`).then(res => res.data)

// // --- Valores Agrícolas (por zona y cultivo) ---
// export const getValoresAgro = () =>
//   axios.get(`${BASE_URL}/parametros/valores-agro`).then(res => res.data)

// export const saveValorAgro = (data) =>
//   axios.post(`${BASE_URL}/parametros/valores-agro`, data).then(res => res.data)

// export const deleteValorAgro = (id) =>
//   axios.delete(`${BASE_URL}/parametros/valores-agro/${id}`).then(res => res.data)

// // --- Valores Ganadería ---
// export const getValoresGanaderia = () =>
//   axios.get(`${BASE_URL}/parametros/valores-ganaderia`).then(res => res.data)

// export const saveValorGanaderia = (data) =>
//   axios.post(`${BASE_URL}/parametros/valores-ganaderia`, data).then(res => res.data)

// export const deleteValorGanaderia = (id) =>
//   axios.delete(`${BASE_URL}/parametros/valores-ganaderia/${id}`).then(res => res.data)

// // --- Valores Generales (Tambo) ---
// export const getValoresGenerales = () =>
//   axios.get(`${BASE_URL}/parametros/valores-generales`).then(res => res.data)

// export const saveValorGeneral = (data) =>
//   axios.post(`${BASE_URL}/parametros/valores-generales`, data).then(res => res.data)

// export const deleteValorGeneral = (id) =>
//   axios.delete(`${BASE_URL}/parametros/valores-generales/${id}`).then(res => res.data)

// // --- Cultivos (ya existe getCultivos, agregar save y delete) ---
// export const saveCultivo = (data) =>
//   axios.post(`${BASE_URL}/dominios/cultivos`, data).then(res => res.data)

// export const deleteCultivo = (id) =>
//   axios.delete(`${BASE_URL}/dominios/cultivos/${id}`).then(res => res.data)

// =====================================================
// AGREGAR A api/agro.js
// Funciones CRUD para Administración de Parámetros
// =====================================================
// Dominios → /api/agro/dominios/* (DominioController existente)
// Parámetros → /api/agro/parametros/* (ParametrosAgroController nuevo)
// =====================================================

// ===== ZONAS AGROPECUARIAS (DominioController) =====
export const getZonasAgro = () =>
  axios.get(`${BASE_URL}/dominios/zonas`).then(res => res.data)

export const saveZonaAgro = data =>
  axios.post(`${BASE_URL}/dominios/zonas`, data).then(res => res.data)

export const deleteZonaAgro = id =>
  axios.delete(`${BASE_URL}/dominios/zonas/${id}`).then(res => res.data)

// ===== CULTIVOS (DominioController - GET ya existe, agrega POST/DELETE) =====
// NOTA: Si ya tenés getCultivos() apuntando a /dominios/cultivos, no la dupliques
// export const getCultivos = () =>
//   axios.get(`${BASE_URL}/dominios/cultivos`).then(res => res.data)

export const saveCultivo = data =>
  axios.post(`${BASE_URL}/dominios/cultivos`, data).then(res => res.data)

export const deleteCultivo = id =>
  axios.delete(`${BASE_URL}/dominios/cultivos/${id}`).then(res => res.data)

// ===== CONCEPTOS PLAN PRODUCTIVO (DominioController) =====
export const getConceptosPlan = () =>
  axios.get(`${BASE_URL}/dominios/conceptos-plan`).then(res => res.data)

export const saveConceptoPlan = data =>
  axios.post(`${BASE_URL}/dominios/conceptos-plan`, data).then(res => res.data)

export const deleteConceptoPlan = id =>
  axios
    .delete(`${BASE_URL}/dominios/conceptos-plan/${id}`)
    .then(res => res.data)

// ===== VALORES AGRÍCOLAS (ParametrosAgroController) =====
export const getValoresAgro = () =>
  axios.get(`${BASE_URL}/parametros/valores-agro`).then(res => res.data)

export const saveValorAgro = data =>
  axios.post(`${BASE_URL}/parametros/valores-agro`, data).then(res => res.data)

export const deleteValorAgro = id =>
  axios
    .delete(`${BASE_URL}/parametros/valores-agro/${id}`)
    .then(res => res.data)

// ===== RENDIMIENTO OFICIAL MAGyP (ParametrosAgroController) =====
// BDSJEA-153: la serie de Estimaciones Agrícolas se carga por archivo. Ver el
// comentario del controller sobre por qué no se descarga automáticamente.
export const getImportacionesRendimientoOficial = () =>
  axios
    .get(`${BASE_URL}/parametros/rendimiento-oficial/importaciones`)
    .then(res => res.data)

export const getResumenRendimientoOficial = () =>
  axios
    .get(`${BASE_URL}/parametros/rendimiento-oficial/resumen`)
    .then(res => res.data)

// Devuelve { total, filas }: el paginado es del lado del servidor.
export const getSerieRendimientoOficial = (filtros = {}) =>
  axios
    .get(`${BASE_URL}/parametros/rendimiento-oficial/serie`, {
      params: filtros,
    })
    .then(res => res.data)

// Serie completa para los filtros elegidos, sin paginar. Devuelve
// { filas, total, truncado, limite }.
export const exportarSerieRendimientoOficial = (filtros = {}) =>
  axios
    .get(`${BASE_URL}/parametros/rendimiento-oficial/exportar`, {
      params: filtros,
    })
    .then(res => res.data)

export const getOpcionesRendimientoOficial = () =>
  axios
    .get(`${BASE_URL}/parametros/rendimiento-oficial/opciones`)
    .then(res => res.data)

export const importarRendimientoOficial = archivo => {
  const formData = new FormData()
  formData.append("archivo", archivo)

  return axios
    .post(`${BASE_URL}/parametros/rendimiento-oficial/importar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(res => res.data)
}

// ===== CALENDARIO AGRÍCOLA (ParametrosAgroController) =====
// BDSJEA-143: la tabla agro.calendario_agricola no tenía ABM. Es referencia
// agronómica (ventanas de siembra y cosecha, días de ciclo, rendimiento de
// zona) de fuente INTA y bolsas; no tiene precios y no se sincroniza con el
// mercado.
export const getCalendariosAgricolas = () =>
  axios.get(`${BASE_URL}/parametros/calendario-agricola`).then(res => res.data)

export const saveCalendarioAgricola = data =>
  axios
    .post(`${BASE_URL}/parametros/calendario-agricola`, data)
    .then(res => res.data)

export const deleteCalendarioAgricola = id =>
  axios
    .delete(`${BASE_URL}/parametros/calendario-agricola/${id}`)
    .then(res => res.data)

// ===== VALORES GANADERÍA (ParametrosAgroController) =====
export const getValoresGanaderia = () =>
  axios.get(`${BASE_URL}/parametros/valores-ganaderia`).then(res => res.data)

export const saveValorGanaderia = data =>
  axios
    .post(`${BASE_URL}/parametros/valores-ganaderia`, data)
    .then(res => res.data)

export const deleteValorGanaderia = id =>
  axios
    .delete(`${BASE_URL}/parametros/valores-ganaderia/${id}`)
    .then(res => res.data)

// ===== VALORES GENERALES (ParametrosAgroController) =====
export const getValoresGenerales = () =>
  axios.get(`${BASE_URL}/parametros/valores-generales`).then(res => res.data)

export const saveValorGeneral = data =>
  axios
    .post(`${BASE_URL}/parametros/valores-generales`, data)
    .then(res => res.data)

export const deleteValorGeneral = id =>
  axios
    .delete(`${BASE_URL}/parametros/valores-generales/${id}`)
    .then(res => res.data)

// ===== CONFIG PROYECCIÓN CREDITICIA (ProductorController) =====
export const getConfigProyeccion = () =>
  axios.get(`${BASE_URL}/productores/config-proyeccion`).then(res => res.data)

export const getConfigProyeccionLista = () =>
  axios
    .get(`${BASE_URL}/productores/config-proyeccion/lista`)
    .then(res => res.data)

export const updateConfigProyeccion = (id, valor) =>
  axios
    .put(`${BASE_URL}/productores/config-proyeccion/${id}`, { valor })
    .then(res => res.data)

// =====================================================
// FUNCIONES API ADICIONALES PARA ANÁLISIS SATELITAL
// Agregar a src/api/agro.js
// =====================================================

// =====================================================
// ANÁLISIS SATELITAL - SERVICIOS DISPONIBLES
// =====================================================

/**
 * Verifica qué servicios de análisis están disponibles
 * @param {number} idProductor - ID del productor
 * @returns {Promise<{local: boolean, iaExterna: boolean, metodos: string[]}>}
 */
export const getServiciosAnalisisDisponibles = async idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/analisis-satelital/servicios`)
    .then(res => res.data)
    .catch(() => ({ local: true, iaExterna: false, metodos: ["LOCAL"] }))

// =====================================================
// ANÁLISIS SATELITAL - LOCAL
// =====================================================

// /**
//  * Genera análisis satelital con método LOCAL (reglas predefinidas)
//  * @param {number} idProductor - ID del productor
//  * @param {object} datos - Datos del análisis
//  * @returns {Promise<AnalisisSatelitalResponse>}
//  */
// export const generarAnalisisIASatelital = async (idProductor, datos) =>
//   api.post(`/agro/productores/${idProductor}/analisis-satelital/ia`, datos)
//     .then(res => res.data)

// =====================================================
// ANÁLISIS SATELITAL - IA EXTERNA (CLAUDE)
// =====================================================

/**
 * Genera análisis satelital con IA EXTERNA (Claude/Anthropic)
 * @param {number} idProductor - ID del productor
 * @param {object} datos - Datos del análisis
 * @returns {Promise<AnalisisSatelitalResponse>}
 */
export const generarAnalisisIAExternaSatelital = async (idProductor, datos) =>
  axios
    .post(
      `${BASE_URL}/productores/${idProductor}/analisis-satelital/ia-externa`,
      datos,
    )
    .then(res => res.data)

// =====================================================
// ANÁLISIS SATELITAL - CONSULTAS
// =====================================================

// /**
//  * Lista todos los análisis satelitales de un productor
//  * @param {number} idProductor - ID del productor
//  * @returns {Promise<AnalisisSatelitalListDTO[]>}
//  */
// export const getAnalisisSatelitalesProductor = async (idProductor) =>
//   api.get(`/agro/productores/${idProductor}/analisis-satelital`)
//     .then(res => res.data)

/**
 * Obtiene un análisis satelital por ID
 * @param {number} idProductor - ID del productor
 * @param {number} idAnalisis - ID del análisis
 * @returns {Promise<AnalisisSatelitalResponse>}
 */
export const getAnalisisSatelital = async (idProductor, idAnalisis) =>
  axios
    .get(
      `${BASE_URL}/productores/${idProductor}/analisis-satelital/${idAnalisis}`,
    )
    .then(res => res.data)

/**
 * Obtiene el último análisis de un polígono
 * @param {number} idProductor - ID del productor
 * @param {number} idPoligono - ID del polígono
 * @returns {Promise<AnalisisSatelitalResponse>}
 */
export const getUltimoAnalisisPoligono = async (idProductor, idPoligono) =>
  axios
    .get(
      `${BASE_URL}/productores/${idProductor}/analisis-satelital/poligono/${idPoligono}/ultimo`,
    )
    .then(res => res.data)

/**
 * Obtiene análisis con alertas (deterioro/estrés)
 * @param {number} idProductor - ID del productor
 * @returns {Promise<AnalisisSatelitalListDTO[]>}
 */
export const getAlertasAnalisisSatelital = async idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/analisis-satelital/alertas`)
    .then(res => res.data)

/**
 * Elimina un análisis satelital
 * @param {number} idProductor - ID del productor
 * @param {number} idAnalisis - ID del análisis
 * @returns {Promise<void>}
 */
export const eliminarAnalisisSatelital = async (idProductor, idAnalisis) =>
  axios.delete(
    `${BASE_URL}/productores/${idProductor}/analisis-satelital/${idAnalisis}`,
  )

// =====================================================
// ANÁLISIS SATELITAL - PARA INFORME PDF
// =====================================================

/**
 * Obtiene el último análisis de cada polígono para incluir en el PDF
 * @param {number} idProductor - ID del productor
 * @returns {Promise<AnalisisSatelitalResponse[]>}
 */
export const getUltimosAnalisisPorPoligono = async idProductor =>
  axios
    .get(
      `${BASE_URL}/productores/${idProductor}/analisis-satelital/ultimos-por-poligono`,
    )
    .then(res => res.data)

/**
 * Obtiene los análisis satelitales formateados para el informe PDF
 * @param {number} idProductor - ID del productor
 * @returns {Promise<AnalisisSatelitalInformeDTO[]>}
 */
export const getAnalisisSatelitalParaInforme = async idProductor =>
  axios
    .get(
      `${BASE_URL}/productores/${idProductor}/analisis-satelital/para-informe`,
    )
    .then(res => res.data)

// =====================================================
// FUNCIONES API PARA SISA - Agregar a api/agro.js
// =====================================================

// --- SISA (Sistema de Información Simplificado Agrícola) ---

/**
 * Obtiene los datos SISA guardados de un productor
 * @param {number|string} idProductor
 * @returns {Promise<DatosSisaDTO>}
 */
export const getDatosSisa = idProductor =>
  axios.get(`${BASE_URL}/productores/${idProductor}/sisa`).then(res => res.data)

/**
 * Guarda los datos SISA manualmente
 * @param {number|string} idProductor
 * @param {object} datos - Datos del formulario
 * @param {File} archivo - Archivo PDF de constancia (opcional)
 * @returns {Promise<DatosSisaDTO>}
 */
export const saveDatosSisa = (idProductor, datos, archivo) => {
  const formData = new FormData()
  formData.append(
    "datos",
    new Blob([JSON.stringify(datos)], { type: "application/json" }),
  )
  if (archivo) {
    formData.append("constancia", archivo)
  }
  return axios
    .post(`${BASE_URL}/productores/${idProductor}/sisa`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(res => res.data)
}

/**
 * Consulta el SISA automáticamente desde AFIP y guarda los datos
 * @param {number|string} idProductor
 * @returns {Promise<DatosSisaDTO>}
 */
export const consultarSisaAfip = idProductor =>
  axios
    .post(`${BASE_URL}/productores/${idProductor}/sisa/consultar`)
    .then(res => res.data)

/**
 * Consulta pública del SISA por CUIT (sin requerir productor guardado)
 * @param {string} cuit - CUIT sin guiones
 * @returns {Promise<DatosSisaDTO>}
 */
export const consultarSisaPublico = cuit =>
  axios
    .get(`${BASE_URL}/sisa/consulta-publica`, { params: { cuit } })
    .then(res => res.data)

// Parámetros consolidados (rendimientos, costos, ganadería, tambo)
export const getParametrosInforme = () =>
  axios.get(`${BASE_URL}/parametros/parametros-informe`).then(res => res.data)

// Informe completo (proyección, scoring, comparativo, historial, tenencia, NDVI)
export const getInformeCompleto = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/informe-completo`)
    .then(res => res.data)

// =====================================================
// Funciones de Proyección Crediticia
// =====================================================

/**
 * Obtiene la proyección crediticia completa de un productor.
 * @param {number} idProductor - ID del productor
 * @param {number} [montoSolicitado] - Monto solicitado (opcional)
 * @param {number} [plazoMeses=12] - Plazo en meses (opcional)
 */
export const getProyeccionCrediticia = (
  idProductor,
  montoSolicitado,
  plazoMeses,
  // BDSJEA-169: true solo cuando el usuario aprieta Recalcular. Abrir la
  // pantalla no debe dejar una fila en la auditoría de proyecciones.
  registrar = false,
) => {
  let url = `${BASE_URL}/productores/${idProductor}/proyeccion-crediticia?plazoMeses=${plazoMeses || 12}`
  if (montoSolicitado) {
    url += `&montoSolicitado=${montoSolicitado}`
  }
  if (registrar) {
    url += `&registrar=true`
  }
  return axios.get(url).then(res => res.data)
}

/**
 * Obtiene el historial de proyecciones crediticias de un productor.
 */
export const getHistorialProyecciones = idProductor =>
  axios
    .get(`${BASE_URL}/productores/${idProductor}/proyecciones-historial`)
    .then(res => res.data)

/**
 * Obtiene los calendarios agrícolas disponibles.
 * @param {string} [zona] - Filtrar por zona (opcional)
 */
export const getCalendarioAgricola = zona => {
  let url = `${BASE_URL}/productores/calendario-agricola`
  if (zona) url += `?zona=${zona}`
  return axios.get(url).then(res => res.data)
}

export const sincronizarPrecios = () =>
  axios.post(`${BASE_URL}/parametros/sincronizar-precios`).then(res => res.data)

export const actualizarCotizacionBcra = () =>
  axios
    .post(`${BASE_URL}/parametros/actualizar-cotizacion-bcra`)
    .then(res => res.data)

export const getEstadoPrecios = () =>
  axios.get(`${BASE_URL}/parametros/estado-precios`).then(res => res.data)

// =====================================================
// TIPOS DE DATOS (para referencia)
// =====================================================

/**
 * @typedef {Object} AnalisisSatelitalResponse
 * @property {number} id
 * @property {number} idProductor
 * @property {number} idEstablecimiento
 * @property {number} idPoligono
 * @property {string} nombrePoligono
 * @property {string} fechaAntes
 * @property {string} fechaDespues
 * @property {string} fechaGeneracion
 * @property {number} ndviInicial
 * @property {number} ndviFinal
 * @property {number} variacionNdvi
 * @property {string} resumen
 * @property {string} tendencia - "mejora significativa"|"leve mejora"|"estable"|"leve deterioro"|"deterioro significativo"
 * @property {string} estadoVegetacion - "saludable"|"en desarrollo"|"normal"|"atención"|"estrés"
 * @property {string[]} recomendaciones
 * @property {string[]} alertas - Solo en IA_EXT
 * @property {string} diagnosticoDetallado - Solo en IA_EXT
 * @property {string} metodo - "LOCAL"|"IA_EXT"
 * @property {string} modeloIA
 * @property {number} confianzaAnalisis
 */

/**
 * @typedef {Object} AnalisisSatelitalListDTO
 * @property {number} id
 * @property {string} nombreEstablecimiento
 * @property {string} nombrePoligono
 * @property {string} fechaAntes
 * @property {string} fechaDespues
 * @property {string} fechaGeneracion
 * @property {string} tendencia
 * @property {string} estadoVegetacion
 * @property {number} variacionNdvi
 * @property {boolean} incluidoEnInforme
 */

// --- Usuarios ---

export const getUsers = async () => {
  const API_BASE = window.REACT_APP_URL || ""
  const response = await axios.get(`${API_BASE}/ewanapi/v1/usuario`)
  return response.data
}

export const getUsuarioMe = async () => {
  const API_BASE = window.REACT_APP_URL || ""
  const response = await axios.get(`${API_BASE}/ewanapi/v1/usuario/me`)
  return response.data
}

// --- División Geográfica ---

const DOM_BASE = `${BASE_URL}/dominios`

export const getProvinciasAll = () => get(`${DOM_BASE}/provincias/all`)

export const saveProvinciaGeo = data => post(`${DOM_BASE}/provincias`, data)

export const deleteProvinciaGeo = id => del(`${DOM_BASE}/provincias/${id}`)

export const getDepartamentosAll = (provincia, nombre) => {
  const params = new URLSearchParams()
  if (provincia) params.set("provincia", provincia)
  if (nombre) params.set("nombre", nombre)
  const qs = params.toString()
  return get(`${DOM_BASE}/departamentos/all${qs ? `?${qs}` : ""}`)
}

export const getConteoLocalidadesPorDepto = provincia =>
  get(`${DOM_BASE}/departamentos/conteo?provincia=${provincia}`)

export const getLocalidadesAll = (provincia, departamento, nombre) => {
  const params = new URLSearchParams()
  if (provincia) params.set("provincia", provincia)
  if (departamento) params.set("departamento", departamento)
  if (nombre) params.set("nombre", nombre)
  const qs = params.toString()
  return get(`${DOM_BASE}/localidades/all${qs ? `?${qs}` : ""}`)
}

export const saveLocalidadGeo = data => post(`${DOM_BASE}/localidades`, data)

export const deleteLocalidadGeo = id => del(`${DOM_BASE}/localidades/${id}`)

export const getCpsPorLocalidad = id => get(`${DOM_BASE}/localidades/${id}/cps`)

export const buscarLocalidadesPorCp = cp =>
  get(`${DOM_BASE}/localidades/buscar-por-cp?cp=${encodeURIComponent(cp)}`)

export const asociarCpALocalidad = (idLocalidad, codigo) =>
  post(`${DOM_BASE}/localidades/${idLocalidad}/cps`, { codigo })

export const desasociarCp = (idLocalidad, idCp) =>
  del(`${DOM_BASE}/localidades/${idLocalidad}/cps/${idCp}`)

export const getCategoriasGanaderas = (codigoEspecie = null) =>
  get(`${DOM_BASE}/categorias-ganaderas`, {
    params: codigoEspecie ? { especie: codigoEspecie } : {},
  })
